import { Box, Button, Grid, Tooltip } from "@mui/material";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import Popup from "../../../Base/views/Popup";
import { useState } from "react";
import {
  DeleteAIConfigAction,
} from "../../../../../store/Ancillary/AIConfig/Action";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import ApiConfigPopup from "./ApiConfigPopup";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const AIModelConfigGrid = () => {
  const dispatch = useDispatch();

  const [editedRecord, setEditedRecord] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { AiConfigLoading, aiConfigData } = useSelector(
    (state) => state.AncillaryReducer?.AIConfigReducer
  );

  const handleEdit = (currentData) => {
    setEditedRecord(currentData);
    setOpenPopup(true);
  };

  const addMode = () => {
    setEditedRecord(null);
    setOpenPopup(false);
  };
  const handleAdd = () => {
    setEditedRecord(null);
    setOpenPopup(true);
  };
  const handleDeleteConfirm = (id) => {
    setDeleteId(id);
    setDeleteConfirm(true);
  };
  const handleDelete = () => {
    dispatch(DeleteAIConfigAction({ ai_token_configuration_fk: deleteId }));
    setDeleteId(null);
    setDeleteConfirm(false);
  };
  
  const addButton = (
    <Button
      onClick={handleAdd}
      variant="contained"
      className="mpl-primary-btn"
      startIcon={<AddIcon />}
    >
      Add
    </Button>
  );

  return (
    <Grid container spacing={2} style={{ padding: "10px 0px" }}>
      <Grid item xs={12} md={12}>
        <Box>
          <MaterialTable
            isLoading={AiConfigLoading}
            columns={[
              {
                title: "AI Provider",
                field: "ai_type",
                cellStyle: { padding: "10px 10px 10px 13px" },
              },
              {
                title: "Model",
                field: "ai_token_json",
                cellStyle: { padding: "10px 10px 10px 13px" },
                render: (rowData) => rowData?.ai_token_json?.display_name,
              },
              {
                title: "Applied",
                field: "ai_token_json",
                cellStyle: { padding: "10px 10px 10px 13px", textAlign: "center" },
                headerStyle: { padding: "10px 10px 10px 13px", textAlign: "center" },
                render: rowData => {
                  return rowData.resume_processor_selection || rowData?.profile_scoring_selection ? 
                  <Tooltip title={rowData.profile_scoring_selection && rowData.resume_processor_selection ? "Resume Processor & Profile Scoring" : rowData.resume_processor_selection ? "Resume Processor" : rowData.profile_scoring_selection ? "Profile Scoring" : ""}>
                    <TaskAltIcon sx={{ color: "rgb(86, 202, 0)"}} />
                  </Tooltip>
                    : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)"}} />
                }
              },
            ]}
            data={aiConfigData}
            options={{
              maxBodyHeight: 240,
              minBodyHeight: 240,
              rowStyle: { fontSize: "13px" },
              headerStyle: { padding: "5px 10px", fontWeight: "bold" },
              sorting: false,
              search: false,
              searchFieldAlignment: "right",
              searchAutoFocus: true,
              searchFieldVariant: "standard",
              filtering: false,
              paging: false,
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              addRowPosition: "first",
            }}
            actions={[
              (rowData) => ({
                icon: (props) => (
                  <EditIcon
                    sx={{ color: props?.disabled ? "#bdbdbd" : "#637381" }}
                  />
                ),
                tooltip: rowData?.is_default ? "Default" : "Edit",
                onClick: (_event, rowData) => {
                  handleEdit(rowData);
                },
                disabled: rowData?.is_default,
              }),
              (rowData) => ({
                icon: (props) => (
                  <DeleteIcon
                    sx={{ color: props?.disabled ? "#bdbdbd" : "#637381" }}
                  />
                ),
                tooltip: rowData?.is_default ? "Default" : rowData?.profile_scoring_selection || rowData?.resume_processor_selection ? "Applied" : "Delete",
                onClick: (_event, rowData) => {
                  handleDeleteConfirm(rowData?.ai_token_configuration_pk);
                },
                disabled: rowData?.is_default || rowData?.profile_scoring_selection || rowData?.resume_processor_selection,
              }),
            ]}
            title={""}
            components={{
              Toolbar: (props) => (
                <Box
                  sx={{
                    minHeight: "10px",
                    padding: "10px 16px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {addButton}
                </Box>
              ),
            }}
          />
          <Popup
            title={"AI Configuration"}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            width="600px"
            sx={{
              "& .MuiPaper-root": {
                maxWidth: "600px",
                overflow: "hidden",
              },
            }}
          >
            <ApiConfigPopup
              editedRecord={editedRecord}
              addMode={addMode}
              setOpenPopup={setOpenPopup}
            />
          </Popup>
          <ConfirmationDialog
            title="Delete AI Configuration"
            content={"Are you sure you want to delete this configuration?"}
            openDialog={deleteConfirm}
            closeDialog={setDeleteConfirm}
            OkButtonText="OK"
            onSubmit={handleDelete}
          />
          
        </Box>
      </Grid>
    </Grid>
  );
};

export default AIModelConfigGrid;